const rootURL = `https://suiteapi.mahavedika.com`
// const rootURL = `http://localhost:3001`
export const configSettings = {
    appURL: rootURL,
    mediaURL: `${rootURL}/media`
}